// 工作台的刷新相关操作
import EventBus from '@/utils/EventBus.js'
const refreshList = 'REFRESH_LIST' // 刷新工单list
const closeIM = 'CLOSE_CURRENT_IM' // 关闭当前群组
const refreshMain = 'REFRESH_MAIN' // 刷新当前处理中工单
const finishOrder = 'FINISH_ORDER' // 完成工单
const initOrderSortStatus = 'INIT_ORDER_SORT_STATUS' //初始化处理中工单筛选条件
const refreshSchedule = 'REFRESH_SCHEDULE' // 更新医生排班
// 刷新工单list
export const REFRESH_LIST = {
  on: callBack => {
    EventBus.on(refreshList, callBack)
  },
  emit: () => {
    EventBus.emit(refreshList)
  },
  off: () => {
    EventBus.off(refreshList)
  }
}
// 关闭当前群组
export const CLOSE_CURRENT_IM = {
  on: callBack => {
    EventBus.on(closeIM, callBack)
  },
  emit: () => {
    EventBus.emit(closeIM)
  },
  off: () => {
    EventBus.off(closeIM)
  }
}
// 刷新当前处理中工单
export const REFRESH_MAIN = {
  on: callBack => {
    EventBus.on(refreshMain, callBack)
  },
  emit: () => {
    EventBus.emit(refreshMain)
  },
  off: () => {
    EventBus.off(refreshMain)
  }
}
// 完成工单
export const FINISH_ORDER = {
  on: callBack => {
    EventBus.on(finishOrder, callBack)
  },
  emit: () => {
    EventBus.emit(finishOrder)
  },
  off: () => {
    EventBus.off(finishOrder)
  }
}
// 初始化处理中工单筛选条件
export const INIT_ORDER_SORT_STATUS = {
  on: callBack => {
    EventBus.on(initOrderSortStatus, callBack)
  },
  emit: () => {
    EventBus.emit(initOrderSortStatus)
  },
  off: () => {
    EventBus.off(initOrderSortStatus)
  }
}
// 更新医生排班
export const REFRESH_SCHEDULE = {
  on: callBack => {
    EventBus.on(refreshSchedule, callBack)
  },
  emit: () => {
    EventBus.emit(refreshSchedule)
  },
  off: () => {
    EventBus.off(refreshSchedule)
  }
}
